<div class="login-account-lockout">
    <div mat-dialog-title class="login-account-lockout-header">
        <button type="button" class="dialog-close" mat-dialog-close><i class="fas fa-times"></i></button>
        <h2 class="subhead dialog-title">Account Locked</h2>
    </div>
    <mat-dialog-content>
        <p>Your account has been temporarily locked out because of too many incorrect login attempts. Please try again in...</p>
        <div class="login-countdown-ctr">
            <app-countdown (completed)="onCountdownCompleted()"></app-countdown>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="login-account-lockout-actions">
        <div class="login-account-lockout-buttons-ctr">
            <button mat-dialog-close class="login-btn-submit" [routerLink]="passwordResetRoute">Reset Password</button>
            <button [mat-dialog-close]="true" class="login-btn-submit" [disabled]="!countdownCompleted" cdkFocusInitial>Try Again</button>
        </div>
        <div class="login-account-lockout-help-ctr">
            <app-login-footer-help></app-login-footer-help>
        </div>
    </mat-dialog-actions>
</div>
